// Totaux d'une pièce à partir de ses lignes, TVA calculée par taux.
// Même règle que la fonction SQL recompute_billing_totals : montant de ligne arrondi
// au centime, TVA arrondie par taux sur la somme HT de ce taux, TTC = HT + TVA.

export type LineNature = 'honoraires' | 'frais' | 'provision';

export const LINE_NATURE_LABELS: Record<LineNature, string> = {
  honoraires: 'Honoraires',
  frais: 'Frais',
  provision: 'Provision',
};

/** Taux proposés dans l'éditeur, du plus courant au moins courant. */
export const VAT_RATE_OPTIONS = [20, 10, 5.5, 0] as const;

/** « 20 % », « 5,5 % ». */
export function formatVatRate(rate: number | string): string {
  return `${String(Number(rate)).replace('.', ',')} %`;
}

export interface TotalsLine {
  quantity: number | string;
  unit_price: number | string;
  /** Taux de la ligne ; absent ou null = taux du document. */
  vat_rate?: number | string | null;
}

export interface RateTotal {
  rate: number;
  ht: number;
  vat: number;
}

export interface LineTotals {
  ht: number;
  vat: number;
  ttc: number;
  /** Une entrée par taux présent, du plus petit au plus grand. */
  byRate: RateTotal[];
}

function cents(value: number): number {
  return Math.round((value + Number.EPSILON) * 100);
}

export function computeLineTotals(lines: TotalsLine[], documentRate: number): LineTotals {
  const htCentsByRate = new Map<number, number>();
  for (const line of lines) {
    const rate = line.vat_rate === null || line.vat_rate === undefined ? Number(documentRate) : Number(line.vat_rate);
    const lineCents = cents(Number(line.quantity) * Number(line.unit_price));
    htCentsByRate.set(rate, (htCentsByRate.get(rate) ?? 0) + lineCents);
  }
  const byRate = [...htCentsByRate.entries()]
    .sort(([a], [b]) => a - b)
    .map(([rate, htCents]) => ({ rate, ht: htCents / 100, vat: cents((htCents / 100) * (rate / 100)) / 100 }));
  const htCents = byRate.reduce((sum, r) => sum + cents(r.ht), 0);
  const vatCents = byRate.reduce((sum, r) => sum + cents(r.vat), 0);
  return { ht: htCents / 100, vat: vatCents / 100, ttc: (htCents + vatCents) / 100, byRate };
}
